// extracted by mini-css-extract-plugin
module.exports = {"faq-section":"FAQSection-module__faq-section___1QWBk","questions":"FAQSection-module__questions___3c76P","question":"FAQSection-module__question____CymQ"};